import { render, staticRenderFns } from "./myCourseNew.vue?vue&type=template&id=256466d9&scoped=true"
import script from "./myCourseNew.vue?vue&type=script&lang=js"
export * from "./myCourseNew.vue?vue&type=script&lang=js"
import style0 from "./myCourseNew.vue?vue&type=style&index=0&id=256466d9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256466d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('256466d9')) {
      api.createRecord('256466d9', component.options)
    } else {
      api.reload('256466d9', component.options)
    }
    module.hot.accept("./myCourseNew.vue?vue&type=template&id=256466d9&scoped=true", function () {
      api.rerender('256466d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/keeCourses/myCourseNew.vue"
export default component.exports